<ion-header no-border mode="md">
    <ion-toolbar color="primary" mode="md">
        <ion-title>
            {{ 'emailSendModal.title' | translate }}
        </ion-title>
        <ion-buttons slot="end">
            <ion-button color="light" (click)="close()" mode="ios">
                <ion-icon class="bp-close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content class="content">
    <div class="container-wrapper">
        <!-- Voltar para lista -->
        <div class="back-link" (click)="goBack()">
            <ion-icon name="arrow-back-outline"></ion-icon>
            <span>{{ 'emailSendModal.backToReportsList' | translate }}</span>
        </div>

        <!-- Informações do Job -->
        <div class="job-info">
            <h3 class="job-title">{{ job.jobName | translate }}</h3>
            <p class="job-description">
                {{ 'emailSendModal.description' | translate }}
            </p>
            <p class="recipients-count">{{ recipientsCountText }}</p>
        </div>

        <!-- Busca de usuários -->
        <div class="search-container" #searchContainer>
            <div class="search-input-wrapper">
                <ion-icon name="search-outline" class="search-icon"></ion-icon>
                <input
                    type="text"
                    class="search-input"
                    [placeholder]="'emailSendModal.searchPlaceholder' | translate"
                    [(ngModel)]="searchQuery"
                    (input)="onSearchChange($event)"
                />
            </div>

            <div class="search-results" *ngIf="showResults && !isSearching">
                <app-email-chip
                        *ngFor="let recipient of searchResults"
                        [recipient]="recipient"
                        [removable]="false"
                        [isSearchResult]="true"
                        (click)="selectUser(recipient)"
                ></app-email-chip>

                <!-- Load More Button -->
                <div class="load-more-container" *ngIf="hasMoreResults && !isLoadingMore">
                    <ion-button fill="clear" size="small" (click)="loadMoreResults()">
                        <ion-icon name="chevron-down-outline" slot="start"></ion-icon>
                        {{ 'emailSendModal.loadMore' | translate }}
                    </ion-button>
                </div>

                <!-- Loading More -->
                <div class="load-more-loading" *ngIf="isLoadingMore">
                    <ion-spinner name="crescent" class="small-spinner"></ion-spinner>
                    <span>{{ 'emailSendModal.loadingMore' | translate }}</span>
                </div>
            </div>

            <!-- Loading -->
            <div class="search-loading" *ngIf="isSearching">
                <ion-spinner name="crescent"></ion-spinner>
                <span>{{ 'emailSendModal.searching' | translate }}</span>
            </div>
        </div>

        <div class="recipients-container">
            <app-email-chip
                *ngFor="let recipient of selectedRecipients"
                [recipient]="recipient"
                (remove)="removeRecipient($event)"
            ></app-email-chip>
        </div>
    </div>

    <ion-footer class="footer-buttons">
        <ion-toolbar>
            <div class="button-container">
                <ion-button fill="outline" color="primary" (click)="goBack()">
                    {{ 'generic.goBack' | translate }}
                </ion-button>
                <ion-button class="btn-send" color="primary" (click)="sendEmails()">
                    <ion-icon name="send-outline" slot="start"></ion-icon>
                    {{ 'emailSendModal.sendToSelected' | translate }}
                </ion-button>
            </div>
        </ion-toolbar>
    </ion-footer>
</ion-content>
